<template>
    <div>
        <div v-for="i in depth" :key="i" class="campo">
            <div class="label">{{ __('Tópico / Categoria') }}</div>
            <v-select
                class="alo-select"
                v-model="nestedDepartmentSelection[i - 1]"
                label="nome"
                :options="departmentsAtLevel(i - 1)"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import VSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    components: { VSelect },
    props: ['workspaceId'],
    mounted() {
        this.loadDepartments()
    },
    data() {
        return {
            departments: [],
            nestedDepartmentSelection: [],
        }
    },
    watch: {
        nestedDepartmentSelection: {
            deep: true,
            handler(value) {
                // Quando qualquer etapa da seleção de departamentos mudar, é necessário
                // varrer o array para limpar dangling pointers.
                for (let i = 0; i < value.length; i++) {
                    let current = value[i]
                    let next = value[i + 1]

                    if (current && next && next.id_pai != current.id) {
                        this.nestedDepartmentSelection = this.nestedDepartmentSelection.slice(0, i + 1)
                        break
                    }
                }

                let latest = this.nestedDepartmentSelection[this.nestedDepartmentSelection.length - 1]

                if (!latest) {
                    this.$emit('select', null)
                    return
                }

                if (!latest.children || latest.children.length == 0) {
                    // leaf dept
                    this.$emit('select', latest)
                } else {
                    this.$emit('select', null)
                }
            },
        },
    },
    computed: {
        depth() {
            let latest = this.nestedDepartmentSelection[this.nestedDepartmentSelection.length - 1]

            if (latest && latest.children.length > 0) {
                return this.nestedDepartmentSelection.length + 1
            }

            return Math.max(this.nestedDepartmentSelection.length, 1)
        },
    },
    methods: {
        async loadDepartments() {
            let { data } = await axios.get('/api/core/departments/contact_form_tree', {
                params: {
                    space_id: this.workspaceId,
                },
            })

            this.departments = data
        },

        departmentsAtLevel(i) {
            if (!this.departments) return []

            if (i === 0) {
                return this.departments.filter((d) => !d.id_pai)
            }

            let parent = this.nestedDepartmentSelection[i - 1]
            if (parent) {
                return parent.children
            }

            return []
        },
    },
}
</script>
